//import {useEffect} from 'react'
//import {useAuth} from './core/Auth'
import {Navigate, Routes} from 'react-router-dom'
import { getAuth } from 'firebase/auth';

export function Logout() {

  const auth = getAuth();
  try {
     auth.signOut();
    localStorage.clear()
    // Navigate('/auth/login')
  } catch (error) {
    console.log(error);
  }
  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
